import {
    GET_CATEGORIES_FOR_ADMIN_REQUEST,
    GET_CATEGORIES_FOR_ADMIN_FAIL,
    GET_CATEGORIES_FOR_ADMIN_SUCCESS,

    GET_CATEGORY_REQUEST,
    GET_CATEGORY_FAIL,
    GET_CATEGORY_SUCCESS,

    GET_CATEGORY_TAGS_REQUEST,
    GET_CATEGORY_TAGS_FAIL,
    GET_CATEGORY_TAGS_SUCCESS,

    ADD_CATEGORY_REQUEST,
    ADD_CATEGORY_FAIL,
    ADD_CATEGORY_SUCCESS,

    UPDATE_CATEGORY_REQUEST,
    UPDATE_CATEGORY_FAIL,
    UPDATE_CATEGORY_SUCCESS,

    DELETE_CATEGORY_REQUEST,
    DELETE_CATEGORY_FAIL,
    DELETE_CATEGORY_SUCCESS,

    ADD_CATEGORY_TAG_REQUEST,
    ADD_CATEGORY_TAG_FAIL,
    ADD_CATEGORY_TAG_SUCCESS,

    REMOVE_CATEGORY_TAG_REQUEST,
    REMOVE_CATEGORY_TAG_FAIL,
    REMOVE_CATEGORY_TAG_SUCCESS,
} from '../constants/AdminCategoryConstants'


const initialState = {
    adminCategories: [],
    loadingCategories: false,
    errorCategories: null,

    loadingCategory: false,
    errorCategory: null,
    category: {},

    loadingAddCategory: false,
    errorAddCategory: null,
    successAddCategory: false,

    loadingUpdateCategory: false,
    errorUpdateCategory: null,
    successUpdateCategory: false,

    loadingDeleteCategory: false,
    errorDeleteCategory: null,
    successDeleteCategory: false,
}


export const adminCategoriesReducer = (state = initialState, action) => {
  switch (action.type){
    case GET_CATEGORIES_FOR_ADMIN_REQUEST:
      return { loadingCategories: true, adminCategories:[] }

    case GET_CATEGORIES_FOR_ADMIN_SUCCESS:
      return { 
        loadingCategories: false, 
        ...state,
        adminCategories: action.payload 
      }

    case GET_CATEGORIES_FOR_ADMIN_FAIL:
      return { loadingCategories: false, errorCategories: action.payload }


    case ADD_CATEGORY_REQUEST:
      return { loadingAddCategory: true, ...state }

    case ADD_CATEGORY_SUCCESS:
      return { 
        loadingAddCategory: false, 
        successAddCategory: true, 
        adminCategories: [action.payload, ...state.adminCategories] 
      }

    case ADD_CATEGORY_FAIL:
      return { 
        loadingAddCategory: false, 
        errorAddCategory: action.payload, 
        ...state 
      }

    case GET_CATEGORY_REQUEST:
        return { loadingCategory: true, ...state }

    case GET_CATEGORY_SUCCESS:
        return { 
            loadingCategory: false, 
            successCategory: true, 
            category: action.payload
        }

    case GET_CATEGORY_FAIL:
        return { 
            loadingCategory: false, 
            errorCategory: action.payload, 
            ...state 
        }

    case UPDATE_CATEGORY_REQUEST:
        return { loadingUpdateCategory: true, ...state }

    case UPDATE_CATEGORY_SUCCESS:
      return { 
        loadingUpdateCategory: false, 
        successUpdateCategory: true, 
        adminCategories: state.adminCategories.map(category => 
          category.id === action.payload.id ? action.payload : category
        ) 
      }

    case UPDATE_CATEGORY_FAIL:
        return { 
            loadingUpdateCategory: false, 
            errorUpdateCategory: action.payload, 
            ...state 
        }

    case DELETE_CATEGORY_REQUEST:
      return { loadingDeleteCategory: true, ...state }

    case DELETE_CATEGORY_SUCCESS:
        return {
          loadingDeleteCategory: false, 
          successDeleteCategory: true, 
          adminCategories: state.adminCategories.filter(category => category.id !== action.category_id) 
        }

    case DELETE_CATEGORY_FAIL:
        return { 
          loadingDeleteCategory: false, 
          errorDeleteCategory: action.payload, 
          ...state 
        }

    default:
      return state
  }
}


const initialTagState = {
    categoryTags: [],
    loadingCategoryTags: false,
    errorCategoryTags: null,

    loadingAddTagToCategory: false,
    errorAddTagToCategory: null,
    successAddTagToCategory: false,

    loadingRemoveTagFromCategory: false,
    errorRemoveTagFromCategory: null,
    successRemoveTagFromCategory: false,
}

export const categoryTagsReducer = (state = initialTagState, action) => {
  switch (action.type){
    case GET_CATEGORY_TAGS_REQUEST:
      return { loadingCategoryTags: true, categoryTags:[] }

    case GET_CATEGORY_TAGS_SUCCESS:
      return { 
        ...state,
        loadingCategoryTags: false, 
        categoryTags: action.payload 
      }

    case GET_CATEGORY_TAGS_FAIL:
      return { loadingCategoryTags: false, errorCategoryTags: action.payload }
    
    case ADD_CATEGORY_TAG_REQUEST:
      return { loadingAddTagToCategory: true, ...state }

    case ADD_CATEGORY_TAG_SUCCESS:
      return { 
        loadingAddTagToCategory: false, 
        successAddTagToCategory: true, 
        categoryTags: [action.payload, ...state.categoryTags] 
      }

    case ADD_CATEGORY_TAG_FAIL:
      return { 
        loadingAddTagToCategory: false, 
        errorAddTagToCategory: action.payload, 
        ...state 
      }

    case REMOVE_CATEGORY_TAG_REQUEST:
      return { loadingRemoveTagFromCategory: true, ...state }

    case REMOVE_CATEGORY_TAG_SUCCESS:
      return { 
        loadingRemoveTagFromCategory: false, 
        successRemoveTagFromCategory: true, 
        categoryTags: state.categoryTags.filter(tag => tag.id !== action.tag_id) 
      }

    case REMOVE_CATEGORY_TAG_FAIL:
      return { 
        loadingRemoveTagFromCategory: false, 
        errorRemoveTagFromCategory: action.payload, 
        ...state 
      }
      
    default:
      return state
  }
}

